import { useState, useEffect } from 'react';

import { useMainMachine } from '../../../utils/useMainMachine';
import { Modal } from '../../../modal/Modal';
import { Button } from '../basic-ui/Button';
import { ACTIONS } from '../../../state';
import { MODAL_ACTIONS } from '../../../modal/modalMachine';
import { NOTIFICATION_ACTIONS } from '../../../notification/notificationLogic';
import { NOTIFICATION_TYPES } from '../../constants';

import { deleteSearchParam, getSearchParam } from '../../../utils/location';

import WarningIcon from '@crazyegginc/hatch/dist/images/icon-warning-filled.svg?react';

export function PermissionRequestedModal() {
  const [userIdToApprove] = useState(() => getSearchParam('uid'));
  const [userEmailToApprove] = useState(() => getSearchParam('uemail'));
  const [isElectron] = useState(() => getSearchParam('is_electron') === 'true');
  const [redirect] = useState(() => getSearchParam('redirect') || null);
  const { useSelector, machine } = useMainMachine();
  const site = useSelector(({ context }) => context.editor.pages.find((p) => p.id === context.activePageId)?.domain);
  const versionId = useSelector(({ context }) => context.activeVersionId);
  const pageId = useSelector(({ context }) => context.activePageId);

  useEffect(() => {
    deleteSearchParam('uid');
    deleteSearchParam('uemail');
  }, []);

  useEffect(() => {
    if (!userIdToApprove || !userEmailToApprove) {
      machine.send({ type: MODAL_ACTIONS.CLOSE });
    }
  }, [machine, userIdToApprove, userEmailToApprove]);

  return (
    <Modal dialogClassName="!top-[150px] !translate-y-0" dismissable={true} disableOutsideClick={true}>
      <WarningIcon className="w-9 h-9 fill-current text-[#FFB202]" />
      <div className="mt-2 text-2xl font-semibold">Publish permission requested</div>

      <div className="text-gray-200 mt-1">
        <span className="text-white font-bold">{userEmailToApprove}</span> has made edits on your site, and is
        requesting approval for publishing access to <span className="text-white font-bold">{site}</span>. You must
        Approve or Deny them.
      </div>

      <div className="text-gray-200 mt-5">
        <span className="text-red-500 font-bold">Warning:</span> Approving them will grant publishing access to{' '}
        <span className="text-white font-bold">{site} now and in the future.</span>
      </div>

      <Modal.Actions>
        <Button
          size="lg"
          onClick={() => {
            machine.send({ type: MODAL_ACTIONS.CLOSE });
            machine.send({
              type: NOTIFICATION_ACTIONS.ADD,
              notification: {
                type: NOTIFICATION_TYPES.ERROR,
                title: 'Publish permission denied!',
                text: `You have denied ${userEmailToApprove} publishing access.`,
              },
            });
          }}
        >
          Deny
        </Button>
        <Button
          size="lg"
          onClick={() => {
            machine.send({ type: MODAL_ACTIONS.CLOSE });
            machine.send({
              type: ACTIONS.APPROVE,
              versionId: versionId,
              pageId,
              userId: Number(userIdToApprove),
              userEmail: userEmailToApprove,
              isElectron,
              redirect,
            });
          }}
        >
          Approve
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
